import { WalletMultiButton } from "@solana/wallet-adapter-react-ui";

export function Header() {
  return (
    <header className="topbar">
      <a className="brand" href="/" aria-label="Tribe Trader home">
        <span className="brand-mark"><i /><i /><i /></span>
        <span>
          <strong>Tribe Trader</strong>
        </span>
      </a>
      <div className="topbar-meta">
        <span className="network-pill"><i /> Solana mainnet</span>
        <WalletMultiButton />
      </div>
    </header>
  );
}
